import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Report } from '../models/invoices/segments.report.model';
import { Options } from '../models/invoices/segments.options.model';
import { JavaConfig } from '../models/invoices/segments.config.model';
import { ConfigService } from '@uxdf/direct-shared-lib';

@Injectable({
  providedIn: 'root'
})
export class BackendInvoiseService {

  constructor(
    private readonly httpClient: HttpClient,
    private readonly initService: ConfigService
  ) {}

  private static filterEmptyParams(params: any) {
    return Object.entries(params)
      .filter(([_, value]) => !!value)
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
  }

  public getInvoicesReport(options: Options): Observable<Report> {
    return this.httpClient.post<Report>(this.getUrl('report'), BackendInvoiseService.filterEmptyParams(options));
  }

  public getJavaConfig(): Observable<JavaConfig> {
    return this.httpClient.get<JavaConfig>(this.getUrl('java-config'));
  }

  public getInvoicesReportFile(options: Options): Observable<Blob> {
    return this.httpClient.post(this.getUrl('report-file'), BackendInvoiseService.filterEmptyParams(options), {
      responseType: 'blob'
    });
  }

  private getUrl(code: string, storeCode?: string): string {
    switch (code) {
      case 'java-config':
        return this.initService.getEnvConfig().AD_JAVA_API_URL + 'api/amadeus/report/config';
      case 'magento-config':
        return this.initService.getEnvConfig().AD_MAGENTO_URL + 'rest/' + storeCode + '/V1/amadeus/public/invoice/config';
      case 'report':
        return this.initService.getEnvConfig().AD_JAVA_API_URL + 'api/amadeus/report';
      case 'report-file':
        return this.initService.getEnvConfig().AD_JAVA_API_URL + 'api/amadeus/report/download';
      default:
        return '';
    }
  }
}
